import React from 'react';
import { projectsData } from '../../data/projectsData';
import SingleProject from './SingleProject/SingleProject';
import './Projects.css';

function Projects() {
    if (!projectsData.length) return null;

    return (
        <section className="projects" id="projects">

            <div className="projects__grid">
                {projectsData.slice(0, 4).map(project => (
                    <SingleProject
                        key={project.id}
                        id={project.id}
                        name={project.projectName}
                        desc={project.projectDesc}
                        tags={project.tags}
                        code={project.code}
                        demo={project.demo}
                        image={project.image}
                    />
                ))}
            </div>

        </section>
    );
}

export default Projects;
